/* classes for reasoning about collection map over state
   null: not a collection?
   NULL_COLLECTION_TYPE_DESCRIPTION: also not a collection. Is there any difference with null ?
   ANY_COLLECTION_TYPE_DESCRIPTION: collection, but will never be mapped over (input has no collection_type)
   CollectionTypeDescription: "normal" collection, with a `collection_type`
*/
export const NULL_COLLECTION_TYPE_DESCRIPTION = {
    isCollection: false,
    collectionType: null,
    rank: 0,
    canMatch: function (other) {
        return false;
    },
    canMapOver: function () {
        return false;
    },
    toString: function () {
        return "NullCollectionType[]";
    },
    append: function (other) {
        return other;
    },
    equal: function (other) {
        return other === this;
    },
    effectiveMapOver: function (other) {
        return NULL_COLLECTION_TYPE_DESCRIPTION;
    },
};
export const ANY_COLLECTION_TYPE_DESCRIPTION = {
    isCollection: true,
    collectionType: "any",
    rank: -1,
    canMatch: function (other) {
        return NULL_COLLECTION_TYPE_DESCRIPTION !== other;
    },
    canMapOver: function () {
        return false;
    },
    toString: function () {
        return "AnyCollectionType[]";
    },
    append: function () {
        return ANY_COLLECTION_TYPE_DESCRIPTION;
    },
    equal: function (other) {
        return other === this;
    },
    effectiveMapOver: function (other) {
        return NULL_COLLECTION_TYPE_DESCRIPTION;
    },
};
export class CollectionTypeDescription {
    constructor(collectionType) {
        Object.defineProperty(this, "collectionType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCollection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rank", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.collectionType = collectionType;
        this.isCollection = true;
        this.rank = collectionType.split(":").length;
    }
    append(other) {
        if (other === NULL_COLLECTION_TYPE_DESCRIPTION) {
            return this;
        }
        if (other === ANY_COLLECTION_TYPE_DESCRIPTION) {
            return other;
        }
        return new CollectionTypeDescription(`${this.collectionType}:${other.collectionType}`);
    }
    canMatch(other) {
        if (other === NULL_COLLECTION_TYPE_DESCRIPTION) {
            return false;
        }
        if (other === ANY_COLLECTION_TYPE_DESCRIPTION) {
            return true;
        }
        return other.collectionType == this.collectionType;
    }
    canMapOver(other) {
        if (!other.collectionType || other.collectionType === "any") {
            return false;
        }
        if (this.rank <= other.rank) {
            // Cannot map over self...
            return false;
        }
        const requiredSuffix = other.collectionType;
        return this._endsWith(this.collectionType, requiredSuffix);
    }
    effectiveMapOver(other) {
        if (other.collectionType && this.canMapOver(other)) {
            const otherCollectionType = other.collectionType;
            const effectiveCollectionType = this.collectionType.substring(0, this.collectionType.length - otherCollectionType.length - 1);
            return new CollectionTypeDescription(effectiveCollectionType);
        }
        return NULL_COLLECTION_TYPE_DESCRIPTION;
    }
    equal(other) {
        if (!other) {
            return false;
        }
        return other.collectionType == this.collectionType;
    }
    toString() {
        return `CollectionType[${this.collectionType}]`;
    }
    _endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }
}
